import React, { useEffect, useState } from "react";
import topLeftBlack from "../assets/images/topLeftButtonBlack.svg";
import bottomRightBlack from "../assets/images/bottomRightButtonBlack.svg";

export const HireUsSide = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Check if at top or bottom of the page
      if (scrollPosition === 0 || scrollPosition + windowHeight >= documentHeight) {
        setIsVisible(false); // Hide component at the top or bottom
      } else {
        setIsVisible(true); // Show component when scrolling in the middle
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Initial check when the component mounts
    handleScroll();

    // Remove scroll event listener on cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Conditionally render the component
  if (!isVisible) {
    return null;
  }

  return (
    <div className="sideHire">
      <button
        onClick={() =>
          window.open("https://calendly.com/abdul-raheem-devsterlabs/30min")
        }
        className="sideButton"
      >
        <img className="btn-tlb" src={topLeftBlack} alt="TLB" />
        <img className="btn-brb" src={bottomRightBlack} alt="BRB" />
        Hire Us
      </button>
    </div>
  );
};
